import Constrants from "./constrants/constrant";

export const fetchSettings = async () => {
  try {
    const response = await Constrants.get('/settings');
    console.log("Settings API response:", response.data);

    // Return the data object from API
    if (response.data.success) {
      return response.data.data; // { website_name, website_description }
    } else {
      console.error("Failed to fetch settings:", response.data);
      return {};
    }
  } catch (error) {
    console.error('Error fetching settings:', error);
    return {};
  }
};
